export default {
    buttons: {
        save: 'Save',
    },
    fields: {
        company_role: {
            label: 'Company role',
            placeholder: 'Select company role',
        },
    },
    select: {
        admin: 'ADMIN',
        user: 'USER',
    },
    errors: {
        user_cannot_change_your_role: "You can't change your role",
    },
}
